module.exports = __webpack_public_path__ + "static/img/banner-bg.4a535f1e.png";